import React from 'react'

import { useAPIGetPerencanaanSatuanPendidikanOptions } from 'api/kinerja/penilik-pegawai/perencanaan'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { SatuanPendidikanItem } from 'types/kinerja-penilik-pegawai'
type SatuanPendidikanProps = {
  rhkId?: string | undefined
}
type SatuanPendidikanHooks = {
  satuanPendidikanData: SatuanPendidikanItem[]
}
export const useSatuanPendidikan = ({
  rhkId,
}: SatuanPendidikanProps): SatuanPendidikanHooks => {
  const { isHavePeriod, period } = usePeriodContext()

  const {
    data: perencanaanSatuanPendidikanResponse,
    isSuccess: isPerencanaanSatuanPendidikanSuccess,
  } = useAPIGetPerencanaanSatuanPendidikanOptions({
    periodeId: period.id,
    rhkId,
    opts: {
      enabled: isHavePeriod && Boolean(rhkId) && rhkId !== '0',
    },
  })

  const satuanPendidikanData = React.useMemo(() => {
    if (isPerencanaanSatuanPendidikanSuccess) {
      return perencanaanSatuanPendidikanResponse?.data ?? []
    }

    return []
  }, [
    isPerencanaanSatuanPendidikanSuccess,
    perencanaanSatuanPendidikanResponse?.data,
  ])

  return {
    satuanPendidikanData,
  }
}
